import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SiteProvider } from "@/lib/site";
import { AuthProvider, useAuth } from "@/lib/auth";
import { InlineEditProvider } from "@/lib/inlineEdit";
import { AdminModeChip } from "@/components/AdminModeChip";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Projects from "@/pages/Projects";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-deep font-mono text-xs text-dim" data-testid="auth-checking">
        $ checking session ...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="min-h-screen bg-ink text-mist">
      <BrowserRouter>
        <HelmetProvider>
          <AuthProvider>
          <SiteProvider>
            <InlineEditProvider>
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                </Routes>
              </main>
              <Footer />
              <AdminModeChip />
              <Toaster theme="dark" position="bottom-right" />
            </InlineEditProvider>
          </SiteProvider>
          </AuthProvider>
        </HelmetProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
